<template>
    <div class="p-2 p-lg-5">
        <div class="row">
            <div class="col-12 ps-4 ms-2">
                <h2>{{ $t("titles.orders") }}</h2>
            </div>
            <div class="col-12 d-flex justify-content-end gap-2">
                <div v-if="$store.getters.hasPerm('can_export_orders')">
                    <button
                        class="btn btn-primary button-top"
                        data-bs-toggle="modal"
                        data-bs-target="#exportOrders"
                    >
                        {{ $t("orders.exportOrderPdf") }}
                    </button>
                </div>
                <div v-if="$store.getters.hasPerm('add_order')">
                    <button
                        @click="createOrder()"
                        class="btn btn-primary button-top"
                    >
                        {{ $t("orders.addOrder") }}
                    </button>
                </div>
            </div>
        </div>
        <Table endpoint="/orders" ref="table" class="mt-3" :filters="filters">
            <template v-slot:filters>
                <div class="row pt-3">
                    <div class="col-3 col-lg-2">{{ $t("orders.id") }}</div>
                    <div class="col-3 col-lg-2" v-if="$store.getters.hasPerm('add_order')">{{ $t("orders.createdDate")
                        }}</div>
                    <div class="col-3 col-lg-2">{{ $t("orders.deliveryDate") }}</div>
                    <div class="col-3 col-lg-2">{{ $t("orders.name") }}/{{ $t("orders.title") }}</div>
                    <div class="col-3 col-lg-2">{{ $t("orders.phone") }}</div>
                    <div class="col-3 col-lg-2">{{ $t("orders.address") }}</div>
                </div>
                <div class="row py-3 item-line">
                    <div class="col-3 col-lg-2">
                        <input type="text" class="form-control" placeholder="23010001" v-model="filters.internId">
                    </div>
                    <div class="col-3 col-lg-2" v-if="$store.getters.hasPerm('add_order')">
                        <input type="date" class="form-control" v-model="filters.createdDateStart">
                        <input type="date" class="form-control" v-model="filters.createdDateEnd">
                    </div>
                    <div class="col-3 col-lg-2">
                        <input type="date" class="form-control" v-model="filters.expectedDeliveryDateStart">
                        <input type="date" class="form-control" v-model="filters.expectedDeliveryDateEnd">
                    </div>
                    <div class="col-3 col-lg-2">
                        <input type="text" class="form-control" placeholder="Matěj Marek" v-model="filters.name">
                    </div>
                    <div class="col-3 col-lg-2">
                        <input type="text" class="form-control" placeholder="736109281" v-model="filters.wholePhone">
                    </div>
                    <div class="col-3 col-lg-2">
                        <input type="text" class="form-control" placeholder="Ulice 11, 110 00 Město"
                            v-model="filters.fullAddress">
                    </div>

                    <div class="row pt-2 fill-background">
                        <div class="col-8 col-lg-2 mt-4 mt-lg-0">{{ $t("orders.warehouse") }}</div>
                        <div class="col-8 col-lg-2 mt-4 mt-lg-0">{{ $t("orders.orderState") }}</div>
                        <div class="col-8 col-lg-2 mt-4 mt-lg-0" v-if="$store.getters.hasPerm('add_order')">{{
                            $t("orders.adtypes") }}</div>
                    </div>
                    <div class="row py-2">
                        <div class="col-8 col-lg-2 mt-4 mt-lg-0">
                            <select class="form-control form-select" id="warehouse" name="warehouse"
                                v-model="filters.warehouse" @change="searchFirstPage">
                                <option :value="null">Všechny</option>
                                <option v-for="warehouse in warehouses" :value="warehouse.id">{{ warehouse.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-8 col-lg-2 mt-4 mt-lg-0">
                            <select class="form-control form-select" id="state" name="state" v-model="filters.state"
                                @change="searchFirstPage">
                                <option :value="null">vše</option>
                                <option value="not_done">nedokončeno</option>
                                <option value="done">dokončeno</option>
                                <!-- <option value="not_complete">nevyplněno</option> -->
                                <option value="hidden">zrušeno</option>
                                <option value="not_collected">nepřevzato</option>
                            </select>
                        </div>
                        <div class="col-8 col-lg-2 mt-4 mt-lg-0" v-if="$store.getters.hasPerm('add_order')">
                            <select class="form-control form-select" id="state" name="state" v-model="filters.adtype"
                                @change="searchFirstPage">
                                <option :value="null">vše</option>
                                <option :value="adtype.id" v-for="adtype in adtypes" v-key="adtype.id">{{ adtype.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-6 col-lg-2 mt-4 mt-lg-0">
                            <button class="btn btn-primary btn-color-white" @click="clearFilters">{{
                                $t("utils.clearFilters") }}</button>
                        </div>
                        <div v-if="$store.getters.hasPerm('can_export_delivery_notes')" class="col-6 col-lg-2 mt-4 mt-lg-0">
                            <button class="btn btn-primary btn-color-white" data-bs-toggle="modal" data-bs-target="#deliveryNotes">{{
                                $t("utils.downloadDeliveryNotes") }}</button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:header>
                <div v-if="$store.getters.hasPerm('can_export_delivery_notes')" class="col-2 col-lg-1">
                    <input type="checkbox" class="form-check-input" @click="selectAll()"
                        style="width: 20px; height: 20px">
                </div>
                <div class="col-3 col-lg-1">{{ $t("orders.id") }}</div>
                <div class="col-3 col-lg-1">{{ $t("orders.deliveryDate") }}</div>
                <div class="col-3 col-lg-2">{{ $t("orders.name") }}</div>
                <div class="col-3 col-lg-2">{{ $t("orders.phone") }}</div>
                <div class="col-3">{{ $t("orders.address") }}</div>
                <div class="col-3 col-lg-2 d-flex">{{ $t("orders.action") }}</div>
            </template>
            <template #row="line">
                <div v-if="$store.getters.hasPerm('can_export_delivery_notes')" class="col-2 col-lg-1">
                    <input type="checkbox" :checked="selectedDeliveryNotes.includes(line.item.id)"
                        @change="selectDeselect(line.item.id)" class="form-check-input"
                        style="width: 20px; height: 20px">
                </div>
                <div class="col-3 col-lg-1">{{ line.item.intern_id }}</div>
                <div class="col-3 col-lg-1">{{ line.item.expected_delivery_date }}</div>
                <div class="col-3 col-lg-2">
                    <span>{{ line.item.customer.name }}</span>
                    <span v-if="line.item.customer.organization_id">
                        ({{ line.item.customer.organization_name }}, {{ line.item.customer.organization_id }})
                    </span>
                </div>
                <div class="col-3 col-lg-2">{{ line.item.customer.whole_phone }}</div>
                <div class="col-3">{{ line.item.customer.address.full_address }}</div>
                <div class="col-3 col-lg-2 d-flex">
                    <router-link :to="'/order/' + line.item.id" class="button link-darker mx-2 ms-0">{{
                        $t("utils.detail")
                    }}</router-link>
                    <router-link :to="'/order/' + line.item.id + '/items'"
                        v-if="!line.item.hidden && $store.getters.hasPerm('change_order')"
                        class="button link-darker mx-2">{{ $t("utils.edit")
                        }}</router-link>
                    <button @click="hideOrder(line.item.id)"
                        v-if="!line.item.hidden && $store.getters.hasPerm('change_order')"
                        class="button link-darker mx-2">{{ $t("utils.cancel") }}</button>
                    <button @click="restoreOrder(line.item.id)" v-else-if="$store.getters.hasPerm('change_order')"
                        class="button link-darker mx-2">{{ $t("utils.restore") }}</button>
                </div>
            </template>
        </Table>
    </div>
    <div class="modal fade" id="deliveryNotes" tabindex="-1" aria-labelledby="deliveryNotesLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="deliveryNotesLabel">{{ $t('orders.makeDeliveryNote') }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3 w-50">
                        <label for="deliveryNotesDate" class="form-label">{{ $t('orders.supplier') }}</label>
                        <select class="form-select" v-model="supplier" id="supplier">
                            <option v-for="supplier in suppliers" :value="supplier.id">
                                {{ supplier.name }}
                            </option>
                        </select>
                    </div>
                    <div class="mb-3 w-50">
                        <label for="deliveryNotesDate" class="form-label">{{ $t('orders.language') }}</label>
                        <select class="form-select" v-model="language" id="language">
                            <option value="cs">
                                Čeština
                            </option>
                            <option value="de">
                                Němčina
                            </option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        <span>{{ $t('utils.close') }}</span>
                    </button>
                    <button type="button" class="btn btn-primary" @click="downloadDeliveryNotes()">
                        <span>{{ $t('utils.submit') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal for export orders -->
    <div class="modal fade" id="exportOrders" tabindex="-1" aria-labelledby="exportOrdersLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exportOrdersLabel">{{ $t("orders.exportOrderPdf") }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3 w-50">
                        <label for="exportOrdersSelect" class="form-label">{{ $t("orders.warehouse") }}</label>
                        <select id="exportOrdersSelect" class="form-select" v-model="selectedWarehouse">
                            <option
                                v-for="warehouse in warehouses"
                                :value="warehouse.id"
                                :key="warehouse.id"
                            >
                                {{ warehouse.name }}
                            </option>
                            <option value="all">{{ $t("utils.all") }}</option>
                        </select>
                    </div>

                    <div class="row g-2">
                        <div class="col-6">
                            <label class="form-label">{{ $t("orders.from") }}</label>
                            <input
                                type="date"
                                class="form-control"
                                v-model="ordersExport.from"
                            />
                        </div>
                        <div class="col-6">
                            <label class="form-label">{{ $t("orders.to") }}</label>
                            <input
                                type="date"
                                class="form-control"
                                v-model="ordersExport.to"
                            />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        <span>{{ $t('utils.close') }}</span>
                    </button>
                    <button type="button" class="btn btn-primary" @click="downloadOrders">
                        <span>{{ $t('utils.submit') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Table from "@/components/Table.vue";

export default {
    components: {
        Table
    },
    data() {
        return {
            warehouses: [],
            adtypes: [],
            supplier: null,
            language: null,
            suppliers: [],
            filters: {
                internId: null,
                expectedDeliveryDateStart: null,
                expectedDeliveryDateEnd: null,
                name: null,
                wholePhone: null,
                fullAddress: null,
                warehouse: null,
                adtype: null,
                createdDateStart: null,
                createdDateEnd: null,
                state: null
            },
            selectedDeliveryNotes: [],
            selectedWarehouse: null,
            ordersExport: {
                from: this.getToday(),
                to: this.getToday(),
            }
        }
    },
    created: function () {
        this.loadData();
        if (this.$store.getters.orderFilters) {
            this.filters = this.$store.getters.orderFilters;
        }
    },
    watch: {
        filters: {
            handler: function () {
                this.$store.commit("updateOrderFilters", this.filters);
            },
            deep: true
        },
    },
    methods: {
        loadData: function () {
            this.$store.getters.api.get("/warehouses/own").then((response) => {
                this.warehouses = response.data.items;
            });
            if (this.$store.getters.hasPerm('add_order')) {
                this.$store.getters.api.get('/adtypes').then(function (response) {
                    this.adtypes = response.data.items;
                }.bind(this));
            }
            if (this.isOwnerOrDispecher()) {
                this.$store.getters.api.get("/suppliers").then((response) => {
                    this.suppliers = response.data.items;
                })
            }
        },
        hideOrder: function (id) {
            this.$store.getters.api.delete("/order/" + id + "/delete").then((response) => {
                this.$refs.table.loadData();
            }).catch((response) => {
                alert(this.$t("error." + response?.response?.data?.error_code));
            });
        },
        restoreOrder: function (id) {
            this.$store.getters.api.put("/order/" + id + "/restore").then((response) => {
                this.$refs.table.loadData();
            }).catch((response) => {
                alert(this.$t("error." + response?.response?.data?.error_code));
            });
        },
        createOrder: function () {
            this.$store.getters.api.get("/order/add").then((response) => {
                this.$router.push({ name: "UpdateOrderCustomer", params: { id: response.data.id } })
            })
        },
        clearFilters: function () {
            this.filters = {
                internId: null,
                expectedDeliveryDateStart: null,
                expectedDeliveryDateEnd: null,
                name: null,
                wholePhone: null,
                fullAddress: null,
                warehouse: null,
                adtype: null,
                createdDateStart: null,
                createdDateEnd: null,
                state: null
            }
        },
        selectDeselect(id) {
            if (this.selectedDeliveryNotes.includes(id)) {
                this.selectedDeliveryNotes.splice(this.selectedDeliveryNotes.indexOf(id), 1);
                return;
            }
            this.selectedDeliveryNotes.push(id);

        },
        selectAll() {
            if (this.selectedDeliveryNotes.length == this.$refs.table.items.length) {
                this.selectedDeliveryNotes = [];
            } else {
                const allItems = this.$refs.table.items;
                this.selectedDeliveryNotes = allItems.map(item => item.id);
            }
        },
        downloadDeliveryNotes() {
            if (this.selectedDeliveryNotes.length > 0) {
                this.$store.getters.api.get("download_multiple_delivery_notes", {

                    responseType: 'blob',
                    params: { orders: this.selectedDeliveryNotes, language: this.language, supplier: this.supplier }
                }).then((response) => {

                    const url = window.URL.createObjectURL(new Blob([response.data]));

                    // Create a link element to trigger the download
                    const link = window.document.createElement('a');

                    // Set the filename from the server or fallback to a default name
                    link.href = url;

                    // Use the Blob type to determine the filename with extension
                    link.setAttribute('download', `sloucene_dodaci_list.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
            }
        },
        downloadOrders () {
            if (this.selectedWarehouse && this.ordersExport.from) {
                this.$store.getters.api.get("download-orders", {
                    responseType: "blob",
                    params: {
                        warehouse: this.selectedWarehouse,
                        from: this.ordersExport.from,
                        to: this.ordersExport.to,
                    }
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement("a")

                    link.href = url;
                    link.setAttribute("download", "objednavky.pdf");

                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch(error => {
                    console.error("Error export.", error);
                })
            }
        },
        getToday() {
            const today = new Date();
            return today.toISOString().split("T")[0]
        },
        isOwnerOrDispecher: function () {
            var isOwnerOrDispecher = false;
            this.$store.state.user.functions.forEach(element => {
                if (element.name == "owner") {
                    isOwnerOrDispecher = true;
                }
                else if (element.name == "dispatcher") {
                    isOwnerOrDispecher = true;
                }
            })
            return isOwnerOrDispecher;
        },
    },
}
</script>
<style lang="">

</style>